import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/en/industries/medical-devices/$slug/$subslug")({
  head: ({ params }) => buildRouteHead(`/en/industries/medical-devices/${params.slug}/${params.subslug}`),
  component: SolutionDetail,
});

